function concipientCancelRegistration() {
  const participantNumber = document.getElementById('event-participant-number')
    .dataset.eventParticipantNumber;
  const registrationId = document.getElementById('event-registration-id')
    .dataset.eventRegistrationId;
  const cancelRegistrationButton = document.getElementById(
    'cancel-registration-button'
  );
  var url = document.location.href.split('#')[0];

  cancelRegistrationButton.addEventListener('click', function () {
    $.ajax({
      type: 'POST',
      url: '/api/concipient/remove-participant',
      data: {
        participantNumber: participantNumber,
        eventRegistrationId: registrationId,
      },
      success: function (data) {
        window.location.href = url;
      },
    });
  });
}
